export default __webpack_public_path__ + "static/media/vouchers.ab42675f.svg";